<template>
  <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
    <v-flex xs6 class="inline-block px-4" v-if="modified">
      <v-text-field hide-details :label="$t('Admin.Enseigne.Form.Key')" v-model="ens_libelle" />
      <!-- <v-text-field hide-details  :label="$t('Admin.Enseigne.Form.Surname')" v-model="ens_libelle" />             -->
      <v-switch
        v-if="isSysAdmin || isManager"
        hide-details
        :label="$t('Admin.Enseigne.Form.AdcpOn')"
        v-model="modified.config.ad2cp_on"
      ></v-switch>
      <v-switch
        v-if="isSysAdmin || isManager"
        hide-details
        :label="$t('Admin.Enseigne.Form.AisOn')"
        v-model="modified.config.ais_on"
      ></v-switch>
      <v-switch
        v-if="(isSysAdmin || isManager) && modified.config.ais_on"
        hide-details
        :label="$t('Admin.Enseigne.Form.AisAnticollisionOn')"
        v-model="modified.config.ais_anticollision_on"
      ></v-switch>
      <v-switch
        v-if="isSysAdmin || isManager"
        hide-details
        :label="$t('Admin.Enseigne.Form.PostprocessImageOn')"
        v-model="modified.config.postprocess_image"
      ></v-switch>
      <v-switch
        v-if="isSysAdmin || isManager"
        hide-details
        :label="$t('Admin.Enseigne.Form.QuickControlOn')"
        v-model="modified.config.quickcontrol_on"
      ></v-switch>
      <!-- BLF037 — modules (RG-ACC-047) : Couverture seulement avec Smart Planning, Formation avec
           un des deux modules ; une option masquée est décochée. -->
      <v-switch
        v-if="isSysAdmin || isManager"
        hide-details
        :label="$t('Admin.Enseigne.Form.FleetOn')"
        :input-value="modified.config.fleet_on"
        @change="setModule('fleet_on', $event)"
      ></v-switch>
      <v-switch
        v-if="isSysAdmin || isManager"
        hide-details
        :label="$t('Admin.Enseigne.Form.SmartPlanningOn')"
        :input-value="modified.config.smartplanning_on"
        @change="setModule('smartplanning_on', $event)"
      ></v-switch>
      <v-switch
        v-if="(isSysAdmin || isManager) && modified.config.smartplanning_on"
        hide-details
        class="ml-4"
        :label="$t('Admin.Enseigne.Form.CoverageOn')"
        v-model="modified.config.coverage_on"
      ></v-switch>
      <v-switch
        v-if="(isSysAdmin || isManager) && (modified.config.fleet_on || modified.config.smartplanning_on)"
        hide-details
        class="ml-4"
        :label="$t('Admin.Enseigne.Form.FormationOn')"
        v-model="modified.config.formation_on"
      ></v-switch>
    </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'AdminEnseigneForm',
})
export default class AdminEnseigneForm extends Vue {
  get modified() {
    return this.$store.myGetters.modifiedAdmEnseigne
  }

  // get ens_key() {
  //   return this.modified.ENS_KEY!
  // }
  // set ens_key(value:string) {
  //   this.$store.myActions.ENSEIGNE_UPDATE_MODIFIED_ADM({
  //     ENS_KEY:value
  //   })
  // }

  get ens_libelle() {
    return this.modified.ENS_LIBELLE!
  }
  set ens_libelle(value: string) {
    this.$store.myActions.ENSEIGNE_UPDATE_MODIFIED_ADM({
      ENS_LIBELLE: value,
    })
  }

  // BLF037 — un module décoché décoche les options qu'il masque (pas de valeur cachée).
  setModule(key: 'fleet_on' | 'smartplanning_on', value: boolean) {
    const config = this.modified.config
    config[key] = !!value
    if (!config.smartplanning_on) config.coverage_on = false
    if (!config.fleet_on && !config.smartplanning_on) config.formation_on = false
  }

  get isSysAdmin() {
    return this.$store.getters.isSysAdmin
  }

  get isManager() {
    return this.$store.getters.isManager
  }
}
</script>
